import { DiscountType } from 'consts/newReservationTypes/discountConstants';
import { TServiceTableData } from 'modules/accommodations/features/reservations/models';

export const calculatedDiscountTableTotalAmount = (
  servicesTableData: TServiceTableData[],
  reservationDiscountType: string,
  amountPerDiscountType: number,
) => {
  const servicesTableDataCopy = [...servicesTableData].filter(
    (item: TServiceTableData) => item.isBasicService,
  );

  let calculatedTotalAmount = 0;
  switch (reservationDiscountType) {
    case DiscountType.POP: {
      const sumPricePerUnitOfMeasureAndAmount = servicesTableDataCopy
        .map((item: TServiceTableData) => {
          return item.sellingPricePerUnitOfMeasure * item.amount;
        })
        .reduce((acc, currentValue) => acc + currentValue, 0);

      calculatedTotalAmount = sumPricePerUnitOfMeasureAndAmount * (amountPerDiscountType / 100);
      break;
    }
    case DiscountType.DAN: {
      const min = Math.min(...servicesTableDataCopy.map(item => item.sellingPricePerUnitOfMeasure));
      const result = servicesTableDataCopy.filter(
        item => item.sellingPricePerUnitOfMeasure === min,
      );
      const smallestPricePerUnitOfMeasure = result[0].sellingPricePerUnitOfMeasure;

      calculatedTotalAmount = smallestPricePerUnitOfMeasure * amountPerDiscountType;
      break;
    }
    case DiscountType.FIX:
      calculatedTotalAmount = amountPerDiscountType;
      break;
  }

  return calculatedTotalAmount;
};
